import { forwardRef } from "react";

/**
 * PopInput — chunky rounded input with thick border + hard shadow on focus.
 * Use <PopInput label="EMAIL" .../>
 */
export const PopInput = forwardRef(function PopInput(
  {
    label,
    hint,
    error,
    className = "",
    inputClassName = "",
    "data-testid": testId,
    as = "input",
    rows,
    ...rest
  },
  ref
) {
  const Tag = as;
  return (
    <label className={`block ${className}`}>
      {label ? <span className="t-label mb-2 block">{label}</span> : null}
      <Tag
        ref={ref}
        rows={rows}
        data-testid={testId}
        className={`field ${error ? "field-error" : ""} ${inputClassName}`}
        {...rest}
      />
      {hint && !error ? <span className="t-helper mt-1.5 block">{hint}</span> : null}
      {error ? <span className="t-error mt-1.5 block">{error}</span> : null}
    </label>
  );
});

export default PopInput;
